import Vue from 'vue'
import Vuex from 'vuex'

import sessionStore from '@/stores/session'
import chargesStore from '@/stores/charges'
import overlayStore from '@/stores/overlay'

const deviceStore = {
  namespaced: true,
  state: {
    devices: [],
    devicesPortData: [],
  },
  mutations: {
    SET_DEVICES (state, devices) {
      state.devices = devices
    },
    SET_DEVICE_PORT_DATA (state, portData) {
      state.devicesPortData = portData
    },
  },
  actions: {
    reset({commit, state}) {
      commit('SET_DEVICES', [])
      commit('SET_DEVICE_PORT_DATA', [])
      commit('SET_ACTUAL_BUNDLE_DEVICE_DATA', [{ 'deviceId':'None','portData':[]}])
    },

    /*
    // Fetch specific device graph data
    graph ({commit, state}, deviceId) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(`/rest/profile/${sessionStore.state.profileId}/device/${deviceId}/graph?start=${chargesStore.state.startDate}&end=${chargesStore.state.endDate}`).
        then(response => {
          //console.log("store_device_graph");
          //console.log(response.data);
          response.data.deviceId = deviceId
          //On doit inverser les données puisque le call les envoie du plus récent au plus ancien
          for(var i = 0; i < response.data.portsData.length;i++){
            response.data.portsData[i].data.reverse()
          }
          commit("SET_DEVICE_PORT_DATA", response.data )
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },
    */

    // Fetch specific device data
    readDeviceDataOld ({commit, state}, deviceId) {
      return new Promise((resolve, reject) => {
        Vue.axios.get(`/rest/profile/${sessionStore.state.profileId}/device/${deviceId}/graph?start=${chargesStore.state.startDate}&end=${chargesStore.state.endDate}`).
        then(response => {
          console.log("store_device_readDeviceData");
          console.log(response.data);
          response.data.deviceId = deviceId
          //On doit inverser les données puisque le call les envoie du plus récent au plus ancien
          for(var i = 0; i < response.data.portsData.length;i++){
            response.data.portsData[i].data.reverse()
          }
          state.actualBundleDeviceData.push({ 'deviceId':deviceId,'portData':response.data.portsData})
          console.log(state.actualBundleDeviceData);
          commit("SET_DEVICE_PORT_DATA", response.data )
          resolve()
        }).catch(error => {
          reject(error)
        })
      })
    },







    // Fetch specific device live data
    clearDevices ({commit, state}) {
      commit('SET_DEVICES', [])
    },

    live ({commit, state}, deviceId) {
      console.log('Live call');
    },

    updatePort ({commit, state}, data) {
      return Vue.axios.put(`/rest/profile/${sessionStore.state.profileId}/device/${data.deviceId}/portupdate`, data.portData)
    },

    /*
    updateDevice ({commit, state}, device) {
      let saveObject = {
        name: device.name,
        latitude: device.latitude,
        longitude: device.longitude,
        pricingPlan: device.pricingPlan
      }
      return Vue.axios.put(`/rest/profile/${sessionStore.state.profileId}/device/${device.deviceId}/update`, saveObject)
    },
    */

    //Validation of the DeviceCode before adding to the profile (used by AddDeviceForm)
    validateDeviceId({commit, state},device){
      return Vue.axios.get(`/rest/profile/${sessionStore.state.profileId}/validatedeviceid?deviceId=${device.deviceId}&deviceKey=${device.deviceKey}`)
      .then((response) => {
        //console.log(response.data)
        return Promise.resolve(response)
      })
      
    },

    //Validation of the DeviceCode before adding to the profile (used by AddDeviceForm)
    addDeviceToProfile({commit, state},device){
      return Vue.axios.get(`/rest/profile/${sessionStore.state.profileId}/addrecordeddevice?deviceId=${device.deviceId}&deviceKey=${device.deviceKey}`)
      .then((response) => {
        //console.log(response.data)
        return Promise.resolve(response)
      })
      
    },

    //Validation of the DeviceCode before adding to the profile (used by AddDeviceForm)
    addSubscriptionToDevice({commit, state},device){
      return Vue.axios.get(`/rest/profile/${sessionStore.state.profileId}/addsubscriptiontodevice?deviceId=${device.deviceId}&deviceKey=${device.deviceKey}&template=${device.subscriptionTemplate}&freemonth=${device.monthFree}`)
      .then((response) => {
        console.log(response.data)
        return Promise.resolve(response)
      })
      
    },

    /*
    // Fetch devices listing for a profileId
    devices ({commit, state, dispatch}) {
      return new Promise((resolve, reject) => {
        if (state.devices.length > 0) {
          resolve({data: state.devices})
        } else {
          //Vue.axios.get(`/rest/profile/${sessionStore.state.profileId}/devices`)
          //Vue.axios.get(`/rest/profile/${sessionStore.state.profileId}/devices?deviceGroup=$Test`)
          Vue.axios.get(`/rest/profile/${sessionStore.state.profileId}/devices?deviceGroup=GroupeTest`)
          .then(response => {
            commit('SET_DEVICES', response.data)
            //console.log("store_device_devices");
            //console.log(response.data);
            resolve(response)
          })
          .catch( error => {
            reject(error)
          })
        }
      })
    }
    */

  }
}

export default deviceStore



// WEBPACK FOOTER //
// ./src/stores/device.js